import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import './style.scss';
import './summary';
import {
    LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE,
    LINEKDIN_SUMMARY_TEMPLATE_STATE,
} from './step-contants';
import { STATUS_FAIL, STATUS_SENT, STATUS_SKIP } from './select-message-template';
import MessageFormatter from '../../service/message-formatter';
import { MESSAGE_TYPE_LINKEDIN } from '../../index';
import { CONTACT_CHANNEL_TYPES } from '../../../recruiter/constants/contactTypes';

export class LinkedinMode {
    currentStep = LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE;

    summary = {
        skipped: 0,
        sent: 0,
        failed: 0,
    };

    /* @ngInject */
    constructor($timeout, RouteService, ContactCandidateService) {
        this.$timeout = $timeout;
        this.RouteService = RouteService;
        this.contactCandidateService = ContactCandidateService;
    }

    async $onInit() {
        this.loading = true;
        const templates = await this.getMessageTemplates();

        this.$timeout(() => { this.templates = templates; });
        this.loading = false;
    }

    async getMessageTemplates() {
        const language = this.RouteService.getUserPreference('uiLanguage') || 'en-US';

        return this.contactCandidateService.getMessageTemplatesByContactChannel({
            channel: CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
            language,
            positionId: this.position._id,
        });
    }

    async sendMessage({ message, candidate, selectedMessage }) {
        const { position, summary, employerRep } = this;

        const candidateWebAddress = _.get(candidate, 'candidateData.contact.webAddress', []);
        const candidateLinkedIn = (
            candidateWebAddress.find((address => address.type === CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE),
            ) || {}).url;

        const { result: positionApprovalLinkData } = await this.RouteService.getPositionApprovalLinks(position._id, {
            candidates: [{
                emails: _.get(candidate, 'candidateData.contact.emailAddress') || [],
                talentId: _.get(candidate, 'workflow.talentId'),
                workflowId: _.get(candidate, 'workflow._id'),
                channelType: 'linkedin',
                linkedIn: candidateLinkedIn,
            }],
            sentBy: 'recruiter',
        });

        const messageUuid = _.get(positionApprovalLinkData, '0.messageUuid');
        _.set(selectedMessage, 'messageUuid', messageUuid);

        const positionApprovalLink = _.get(positionApprovalLinkData, '0.link', null);

        const { template: templateWithSubstitutions } = MessageFormatter.fillTemplate(
            { template: message },
            { ...candidate, positionApprovalLink },
            undefined,
            undefined,
            MESSAGE_TYPE_LINKEDIN,
        );

        return this.onSendMessage({
            candidate,
            message:
            templateWithSubstitutions,
            summary,
            selectedMessage,
        });
    }

    skipMessage() {
        this.updateSummary(STATUS_SKIP);
    }

    onSentDone() {
        this.setStep(LINEKDIN_SUMMARY_TEMPLATE_STATE);
    }

    updateSummary(status) {
        if (status === STATUS_SENT) {
            this.summary.sent++;
        }

        if (status === STATUS_FAIL) {
            this.summary.failed++;
        }

        if (status === STATUS_SKIP) {
            this.summary.skipped++;
        }
    }

    setStep(step) {
        this.currentStep = step;
    }
}

export const linkedinModeConfiguration = {
    template,
    controller: LinkedinMode,
    bindings: {
        candidates: '<',
        recruiter: '<',
        position: '<',
        recruiterId: '<',
        employerRep: '<',
        onClose: '&',
        onDone: '&',
        onSendMessage: '&',
    },
    controllerAs: 'linkedinModeCtrl',
};

angular.module('TALENYA-FE')
    .component('linkedinMode', linkedinModeConfiguration);
